import React, { useEffect, useState, useRef } from "react";
import Input from "../../../Input";
import "./style.scss";
import OTPInput from "react-otp-input";
import { autoCapital, formDataGenerator } from "../../../../../../utils/common";
import { bindActionCreators } from "redux";
// import {clearVerifyResponse, checkExistingUser, verifyOTP, clearSendOTP, postInvestDataETF} from "../action";
// import { postInvestDataETF } from '../../../landing/Product/actions';
import { connect } from "react-redux";
import moment from "moment";
import ENV_CONFIG from "../../../../../../config/environment";
import { getAllSchemeDetails } from "../action";
import { openPopup, closePopup } from "../../action";
import { SCHEME_FILTERS } from "../constants";
import FilterModal from "../FilterModal";
import SchemeCard from "./SchemeCard";
import cookie from "react-cookies";

const AllSchemes = (props) => {
  const {
    eCart,
    getAllSchemeDetails,
    openPopup,
    setCartJourneyPage,
    onAddToCartClick,
    closePopup,
  } = props;
  const [fundDetails, setFundDetails] = useState([]);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [filterList, setFilterList] = useState({
    [SCHEME_FILTERS.FUND_CATEGORY.id]: [],
    [SCHEME_FILTERS.TIME_HORIZON.id]: [],
    [SCHEME_FILTERS.GOALS.id]: [],
    [SCHEME_FILTERS.RISK_RATING.id]: [],
  });
  const [searchItem, setSearchItem] = useState("");
  const [toggle, setToggle] = useState(false);
  const [durationValues, setDurationValues] = useState({});
  const [showError, setShowError] = useState(false);
  const [defaultValue, setdefaultValue] = useState(0);

  const onLoad = async () => {
    let response = await getAllSchemeDetails();
    let cartDetailCookie = cookie.load("CartDetails") || {};
    let cartData = Object.values(cartDetailCookie);
    if (cartData?.length > 0) {
      if (cartData[0].isDirect) {
        setToggle(false);
        setdefaultValue(1);
      } else if (cartData[0].isRegular) {
        setToggle(true);
        setdefaultValue(2);
      }
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const onOpenFilterModal = () => {
    setOpenFilterModal((prev) => !prev);
  };

  const addFilter = (filterId, filterValue) => {
    setFilterList((prev) => {
      let result = {
        ...prev,
        [filterId]: [...prev[filterId], filterValue],
      };
      console.log(result);
      return result;
    });
  };

  const removeFilter = (filterId, filterValue) => {
    const filteredResult = filterList[filterId].filter((ele) => {
      return ele !== filterValue;
    });

    setFilterList((prev) => {
      return {
        ...prev,
        [filterId]: filteredResult,
      };
    });
  };

  const onSearchChange = (event) => {
    setSearchItem(event.target.value);
  };

  useEffect(() => {
    let allFunds = [];
    if (eCart.allSchemeDetails.data && eCart.allSchemeDetails.data.funds) {
      allFunds = eCart.allSchemeDetails.data.funds;
    }
    let toggleData = getToggleData(allFunds);
    let searchData = getSearchData(toggleData);
    let filterData = getFilterData(searchData);

    setFundDetails(filterData);
  }, [searchItem, toggle, eCart.allSchemeDetails.data?.funds, filterList]);

  useEffect(() => {
    fundDetails &&
      fundDetails.map((item) => {
        setDurationValues((currentValue) => ({
          ...currentValue,
          [item.fundCode]: "16",
        }));
      });
  }, [fundDetails]);

  const getSearchData = (funds) => {
    if (searchItem.length > 1) {
      let filteredResult = funds?.filter((ele) => {
        let name = ele.fundName.toLowerCase();
        return name.includes(searchItem.toLowerCase());
      });
      return filteredResult;
    } else return funds;
  };

  const getToggleData = (funds) => {
    let fundInfo = [];
    if (!toggle) {
      fundInfo = funds.filter((ele) => {
        return ele.directScheme.length !== 0;
      });
    } else {
      fundInfo = funds.filter((ele) => {
        return ele.regularScheme.length !== 0;
      });
    }
    return fundInfo;
  };

  const getFilterData = (funds) => {
    let filteredResult = funds;
    let categoryFilter = filterList[SCHEME_FILTERS.FUND_CATEGORY.id];
    let timeHorizonFilter = filterList[SCHEME_FILTERS.TIME_HORIZON.id];
    let goalsFilter = filterList[SCHEME_FILTERS.GOALS.id];
    let riskRatingFilter = filterList[SCHEME_FILTERS.RISK_RATING.id];

    if (categoryFilter?.length) {
      filteredResult = funds.filter((ele) => {
        let result = getCommonElements(categoryFilter, ele.fundCategory);
        return result.length != 0;
      });
    }

    if (timeHorizonFilter?.length) {
      filteredResult = filteredResult.filter((ele) => {
        return timeHorizonFilter.includes(ele.timeHorizon);
      });
    }

    if (goalsFilter?.length) {
      filteredResult = filteredResult.filter((ele) => {
        let result = getCommonElements(goalsFilter, ele.goalsType);
        return result.length != 0;
      });
    }

    if (riskRatingFilter?.length) {
      filteredResult = filteredResult.filter((ele) => {
        let result = getCommonElements(riskRatingFilter, ele.riskReturnProfile);
        return result.length != 0;
      });
    }

    return filteredResult;
  };

  const getCommonElements = (array1, array2) => {
    let commonElement = [];
    array1.forEach((ele1) => {
      array2.forEach((ele2) => ele1 === ele2 && commonElement.push(ele1));
    });
    return commonElement;
  };

  const onToggle = () => {
    setToggle((prev) => !prev);
  };

  const onToggleClick = () => {
    if (defaultValue == 1) {
      if (toggle == true) {
        setShowError(false);
      } else {
        setShowError(true);
      }
    } else if (defaultValue == 2) {
      if (toggle == false) {
        setShowError(false);
      } else {
        setShowError(true);
      }
    }
  };

  const onFundsClick = () => {
    setCartJourneyPage(1);
  };

  return (
    <>
      <div className="all-schemes">
        <div className="allschemeiv">
          {/* <img
            src="/images/closeCircle.svg"
            onClick={closePopup}
            className="closeIcon"
          ></img> */}
            <svg width="35" height="35" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onFundsClick}>
            <path d="M25.5492 47.6663C37.2593 47.6663 46.8402 37.9163 46.8402 25.9997C46.8402 14.083 37.2593 4.33301 25.5492 4.33301C13.8392 4.33301 4.2583 14.083 4.2583 25.9997C4.2583 37.9163 13.8392 47.6663 25.5492 47.6663Z" fill="#E4E4E4" />
            <path d="M19.5239 32.1315L31.5746 19.8682" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M31.5746 32.1315L19.5239 19.8682" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <h4 className="title">All Funds</h4>
        </div>

        <div className="searchBar">
          <input
            className="searchInput"
            placeHolder="Search"
            value={searchItem}
            onChange={onSearchChange}
          />
          <div className="searchIcon">
            <img
              src="/images/New/searchwhite.svg"
              alt="search"
              width={15}
              height={15}
            />
          </div>
        </div>
        <div className="filter-container">
          <div className="toggle-filter-button">
            <div className="toggle-button">
              <p>Direct</p>
              <label class="switch">
                <input
                  type="checkbox"
                  onChange={onToggle}
                  checked={toggle}
                ></input>
                <span class="slider round" onClick={onToggleClick}></span>
              </label>
              <p>Regular</p>
            </div>
            <button className="eacrtfilter" onClick={onOpenFilterModal}>
              <img src="/images/New/filter-red.svg"></img>Filter
               {parseInt(filterList[1] && filterList[1].length > 0 ? filterList[1].length : 0) + 
                parseInt(filterList[2] && filterList[2].length > 0 ? filterList[2].length : 0) +
                parseInt(filterList[3] && filterList[3].length > 0 ? filterList[3].length : 0) +
                parseInt(filterList[4] && filterList[4].length > 0 ? filterList[4].length : 0) !=0 ?
                <div className="filterCount">
                {parseInt(filterList[1] && filterList[1].length > 0 ? filterList[1].length : 0) + 
                parseInt(filterList[2] && filterList[2].length > 0 ? filterList[2].length : 0) +
                parseInt(filterList[3] && filterList[3].length > 0 ? filterList[3].length : 0) +
                parseInt(filterList[4] && filterList[4].length > 0 ? filterList[4].length : 0)}
              </div>:''}
            </button>
          </div>
          {showError && (
            <p className="scheme-message">{`You have added ${
              !toggle ? "Regular Scheme" : "Direct Scheme"
            }. Kindly select same scheme plan`}</p>
          )}
        </div>
        {showError == false && (
          <div className="fundListContainer">
            {fundDetails &&
              fundDetails.map((fund) => {
                return (
                  <SchemeCard
                    fund={fund}
                    onAddToCartClick={onAddToCartClick}
                    toggle={toggle}
                    durationValues={durationValues}
                    setDurationValues={setDurationValues}
                  ></SchemeCard>
                );
              })}
          </div>
        )}
      </div>
      {openFilterModal && (
        <FilterModal
          filterList={filterList}
          addFilter={addFilter}
          removeFilter={removeFilter}
          setOpenFilterModal={setOpenFilterModal}
        ></FilterModal>
      )}
      {/* {openFilterModal && <div className="popup_overlay black_overlay filter-modal-overlay" />} */}
      {fundDetails?.length === 0 && (
        <div className="noSchemes">No Schemes Found</div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  eCart: state.eCart,
});

const mapDispatchToProps = (dispatch) => ({
  openPopup: bindActionCreators(openPopup, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  getAllSchemeDetails: bindActionCreators(getAllSchemeDetails, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllSchemes);
